import React from 'react';
import { UseFormReturnType } from '@mantine/form';
import { EmailServerIntegrationType, IMailServer } from '@/services/api/emailServerApiArea/types';
import SshForm from '@/containers/pages/filials/edit/components/tabs/mail-servers/components/mailServerIntegration/components/SshForm';
import ApiForm from '@/containers/pages/filials/edit/components/tabs/mail-servers/components/mailServerIntegration/components/ApiForm';

interface Props {
  form: UseFormReturnType<IMailServer>;
}

const MailServerIntegration = (props: Props) => {
  const { form } = props;

  if (
    !form?.values?.Integration ||
    form?.values?.Integration.Type === EmailServerIntegrationType.None
  ) {
    return;
  }

  if (form.values.Integration.Type === EmailServerIntegrationType.Ssh) {
    return <SshForm form={form} />;
  }

  return <ApiForm form={form} />;
};

export default MailServerIntegration;
